import Vue from 'vue';

Vue.component('video-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            video: null,
            videoPlaying: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.intersect();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        intersect() {
            const options = {
                rootMargin: "300px",
                threshold: 0
            };

            const {video} = this.$refs;

            const observer = new IntersectionObserver((entries, instance) => {
                const isIntersecting =
                    typeof entries[0].isIntersecting === "boolean"
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.setupVideo();
                    instance.unobserve(video);
                }
            }, options);

            observer.observe(video);
        },

        playVideo() {
            this.video.play();
            this.videoPlaying = true;
        },


        async setupVideo() {
            // eslint-disable-next-line import/no-unresolved
            const { default: Plyr } = await import(/* webpackChunkName: "plyr" */ 'plyr');

            this.video = new Plyr(this.$refs.video, {
                settings: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            });

            if (!this.video) {
                return;
            }

            this.video.on('play', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('pause', (event) => {
                this.videoPlaying = false;
            });

            this.video.on('seeking', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('ended', (event) => {
                this.videoPlaying = false;
            });
        },
    },
});
